
import { getBase64ID, getObjectByID } from "../helpers";

export default class SqlRequest{


    constructor(networkID, callback){
    
        const requestID = getBase64ID()

        this.callback = callback

        this.requestID = requestID

        this.request = {
            MessageID: 'SQL_REQUEST',
            RequestID: requestID,
            Queries: [],
            QueryExtensions: [],
            NetworkID: networkID
        }

    }


    addQuery(key, query){

        this.request.Queries.push(
            {Key: key, Query: query}
        )

    }

    addExtension(queryName, extension){

        let hasKey  

        let ext = getObjectByID(queryName, this.request.QueryExtensions, 'Key' )

        if(!ext){
            this.request.QueryExtensions.push({
                Key: queryName,
                Extensions: [extension]
            })
        }else{
            ext.Extensions.push(extension)
        }
    }



    parameterExtension(type, name, value){

        return {
            Type: 3,
            ParameterType: type,
            Name: name,
            Value: value
          }

    }


    toJson(){
        console.log('toJson')
        let json = JSON.stringify(this.request)
        console.log(json)
        return json
    }

}